import en from "./en";

export class I18n {
    constructor(languages = [], overrides = {}, languageModules = {}) {
        this.userLanguage = "en";
        this.languages = languages;
        this.translations = I18n.loadTranslations(languages, languageModules);
        this.overrides = overrides;
        // this.init();
    }

    init() {
        // console.log("Available languages", this.userLanguage, this.languages, this.translations);
    }

    static create(languages = [], overrides = {}, languageModules = {}) {
        return new I18n(languages, overrides, languageModules);
    }

    static loadTranslations(languages, languageModules) {
        const translations = {};
        languages.forEach((language) => {
            if (languageModules[language]) {
                translations[language] = languageModules[language];
            }
        });
        return translations;
    }

    getTranslation(key) {
        if (
            this.overrides[this.userLanguage] &&
            this.overrides[this.userLanguage][key]
        ) {
            return this.overrides[this.userLanguage][key];
        }

        if (
            this.translations[this.userLanguage] &&
            this.translations[this.userLanguage][key]
        ) {
            return this.translations[this.userLanguage][key];
        }

        // Fallback to English if translation is not available
        return en[key] || "";
    }

    getField(key) {
        const language = this.userLanguage;
        if (
            this.overrides[language] &&
            this.overrides[language]["label"] &&
            this.overrides[language]["label"][key]
        ) {
            return this.overrides[language]["label"][key];
        }

        if (
            this.translations[language] &&
            this.translations[language]["label"] &&
            this.translations[language]["label"][key]
        ) {
            return this.translations[language]["label"][key];
        }

        // Fallback to English if translation is not available
        return key || "";
    }
}
